export const trackAnalyticsEvent = async (eventName) => {
  try {
    await fetch(`${process.env.REACT_APP_API_BASE_URL}analytics/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ event: eventName }),
    });
  } catch (e) {
    // Swallow errors to avoid blocking UX
  }
};


